<script lang="ts">
import { defineComponent } from 'vue'
import SelectorCore from '@/components/form/SelectorCore.vue'
const { props, emits } = SelectorCore

export default defineComponent({
  name: 'SelectorLite',

  components: {
    SelectorCore,
  },

  props,

  emits,
})
</script>

<template>
  <nav class="nav">
    <SelectorCore
      :model-value="modelValue"
      :items="items"
      :name="name"
      :unit="unit"
      :is-disabled="isDisabled"
      :default-selector-label="defaultSelectorLabel"
      :default-selector-value="defaultSelectorValue"
      :inline="inline"
      :is-error="isError"
      @change="$emit('change', $event)"
      @update:model-value="$emit('update:modelValue', $event)" />
  </nav>
</template>

<style lang="sass" scoped>
/**
 * SelectorDefault.vue の scoped style を上書くために deep 修飾子を使用。
 * @see https://zenn.dev/karan_coron/articles/87597250de406018e351
 */
.nav
  ::v-deep(.o-selector)
    $root: '.o-selector'
    $icon-width: 8px
    $icon-right-position: 10px
    width: 100%
    display: block
    margin:
      top: 14px
      left: 0
      right: auto

    &:first-child
      margin-top: 0

    #{$root}--label
      width: 100%
      display: inline-block
      line-height: 1
      vertical-align: middle
      position: relative
      +transition

      &::after
        position: absolute
        top: 50%
        right: $icon-right-position
        transform: translateY(-50%)
        +iconArrow(down)

    #{$root}--items
      $icon-margin: 20px
      width: 100%
      padding: 0.75em ($icon-width + $icon-right-position + $icon-margin) 0.75em 1em
      border: none
      border-bottom: 1px solid $border-x-light-gray
      cursor: pointer
      +transition

      +mouseover
        border-color: $border-orange

    &.is-inline
      width: auto
      display: inline-block

    &[data-disabled="true"]
      #{$root}--label
        opacity: 0.4

        &::after
          opacity: 0.3

    &[data-error="true"]
      #{$root}--label
        &::after
          +iconArrow(down, $border-error)

      #{$root}--items
        background-color: transparent
        border-color: $border-error
</style>
